import { Component, OnInit } from '@angular/core';
import { RouteCachingService } from 'src/app/@theme/shared/services/route-caching.service';
import { DashboardService } from '../dashboard.service';
import { AccessRightsService } from 'src/app/core/access-rights/access-right.service';
import { ActionPermission } from 'src/app/core/access-rights/actions';
import { NumberTileComponent } from '../shared/number-tile/number-tile.component';

@Component({
  selector: 'sca-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  imports: [NumberTileComponent]
})
export class DashboardComponent implements OnInit {
  public myRequisitionsCount: number = 0;
  public generalApplicationsCount: number = 0;
  public unprocessedGeneralApplicationsCount: number = 0;
  public liveRequisitionsCount: number = 0;
  public expiredRequisitionsCount: number = 0;
  public pendingApprovalRequisitionsCount: number = 0;
  public expiringRequisitionsCount: number = 0;
  public failedEmailsCount: number = 0;
  public isLoadingTopSectionTiles: boolean = true;
  public isApprover: boolean = false;
  public canManageSettings: boolean = false;

  constructor(private _dashboardService: DashboardService, private _routeCachingService: RouteCachingService, private _accessRightsService: AccessRightsService) { }

  ngOnInit(): void {
    this.canManageSettings = this._accessRightsService.hasAccessTo(ActionPermission.manageSettings);

    this._dashboardService.getDashboardMainData().subscribe(r => {
      this.myRequisitionsCount = r.myRequisitionsCount;
      this.generalApplicationsCount = r.generalApplicationsCount;
      this.unprocessedGeneralApplicationsCount = r.unprocessedGeneralApplicationsCount;
      this.liveRequisitionsCount = r.liveRequisitionsCount;
      this.expiredRequisitionsCount = r.expiredRequisitionsCount;
      this.pendingApprovalRequisitionsCount = r.pendingApprovalRequisitionsCount;
      this.expiringRequisitionsCount = r.expiringRequisitionsCount;
      this.failedEmailsCount = r.failedEmailsCount;
      this.isLoadingTopSectionTiles = false;
      this.isApprover = r.isApprover;
    });
  }

  public onMyRequisitionsClick(): void {
    this._routeCachingService.clearCachedRoutes();
    this._dashboardService.myRequisitionsSelected();
  }

  public onGeneralApplicationsClick(): void {
    this._routeCachingService.clearCachedRoutes();
    this._dashboardService.myGeneralApplicationsClick();
  }

  public onUnprocessedGeneralApplicationsClick(): void {
    this._routeCachingService.clearCachedRoutes();
    this._dashboardService.myUnprocessedGeneralApplicationsClick();
  }

  public onLiveRequisitionsClick(): void {
    this._routeCachingService.clearCachedRoutes();
    this._dashboardService.liveRequisitionsSelected();
  }

  public onExpiredRequisitionsClick(): void {
    this._routeCachingService.clearCachedRoutes();
    this._dashboardService.expiredRequisitionsSelected();
  }

  public onisPendingApprovalRequisitionsClick(): void {
    this._routeCachingService.clearCachedRoutes();
    this._dashboardService.pendingApprovalRequisitionsSelected();
  }

  public onExpiringRequisitionsClick(): void {
    this._routeCachingService.clearCachedRoutes();
    this._dashboardService.expiringRequisitionsSelected();
  }

  public onFailedEmailsClick(): void {
    this._routeCachingService.clearCachedRoutes();
    this._dashboardService.failedEmailsSelected();
  }
}
